import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

export const useRequestRunUninstallCheck = () => {
	const { isPending, mutateAsync, error } = useMutation({
		mutationFn: () =>
			apiClient
				.post(routes.api.pushUninstalls.check)
				.then(handleApiResponse),
	});

	return {
		isLoading: isPending,
		runCheck: mutateAsync,
		error,
	};
};
